import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/AgeVerificationPopup.css';

const AgeVerificationPopup = ({ onAccept, onReject, showDenied }) => {

const handleAcceptClick = () => {
  if (onAccept) onAccept();

  document.cookie = `popupVerified=1; path=/; max-age=300; domain=.Klypadrelm.com; secure; samesite=None`;

  
};

  return (
   <div className="verification-popup">
  {!showDenied ? (
    <div className="popup-content">
      <h2>🔞 Voordat je speelt</h2>
      <h3>Welkom bij Klypadrelm!</h3>
      <p>Dit is een sociaal casinospel ontwikkeld puur voor entertainment.</p>

      <ul className="feature-list">
        <li><span>❌</span> Geen inzetten</li>
        <li><span>❌</span> Geen echt geld</li>
        <li><span>✅</span> 100% gratis</li>
        <li><span>🔞</span> Alleen voor gebruikers van 18 jaar en ouder</li>
        <li><span>🧠</span> Speel verantwoord</li>
      </ul>

      <p className="consent-text">
        Door op Accepteren te klikken, bevestig je dat je ouder bent dan 18 jaar en akkoord gaat met onze:
      </p>
      <ul className="terms-list">
        <li><Link to="/ansvarsfraskrivelse" target="_blank" rel="noopener noreferrer">Disclaimer</Link></li>
        <li><Link to="/ansvarlig-spilling" target="_blank" rel="noopener noreferrer">Verantwoord spelen</Link></li>
        <li><Link to="/personvernregler" target="_blank" rel="noopener noreferrer">Privacyverklaring</Link></li>
      </ul>

      <div className="popup-buttons">
        <button className="accept-button" onClick={handleAcceptClick}>Privacy accepteren</button>
        <button className="reject-button" onClick={onReject}>Weigeren</button>
      </div>
    </div>
  ) : (
    <div className="popup-content denied">
      <h2>⚠️ Toegang geweigerd</h2>
      <p>Je hebt ervoor gekozen om onze voorwaarden niet te accepteren.</p>
      <p>Daarom krijg je geen toegang tot de inhoud van deze pagina.</p>
      <p>Klypadrelm is een gratis sociaal casinoplatform, alleen voor entertainment en voor gebruikers ouder dan 18 jaar.</p>
      <p>Er is geen echt geld, geen inzetten, en geen prijzen.</p>
      <p className="redirect-text">🔙 Doorverwijzen naar de homepage...</p>
    </div>
  )}
</div>

  );
};

export default AgeVerificationPopup;
